import CoachPage from './coach-page'
import CoachPageWithData, { COACH_QUERY } from './coach-page.query'

export { CoachPageWithData, COACH_QUERY }

export default CoachPage
